import dayjs from 'dayjs';
import React, { useRef } from 'react'
import Chart from "react-apexcharts";
import { DatePicker } from 'antd';
import { Heading } from '@chakra-ui/react';
const { RangePicker } = DatePicker;

const ResumesCountChart = ({ seriesData, minDate, maxDate }) => {
    const chartRef = useRef(null);
    const chartData = {
        series: seriesData,
        options: {
            chart: {
                id: 'area-datetime',
                type: 'area',
                zoom: {
                    autoScaleYaxis: true
                },
                events: {
                    mounted: (chart) => {
                        chartRef.current = chart;
                    }
                }
            },
            dataLabels: {
                enabled: false
            },
            markers: {
                size: 0,
                style: 'hollow',
            },
            xaxis: {
                type: 'datetime',
                min: new Date('01 Jan 2024').getTime(),
                tickAmount: 6,
                position: 'bottom'
            },
            yaxis: {
                title: {
                    text: 'No. of Resumes'
                }
            },
            tooltip: {
                x: {
                    format: 'dd MMM yyyy'
                },
                z: {
                    title: 'Pool Name:'
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 100]
                }
            },
            responsive: [
                {
                    breakpoint: 1300,
                    options: {
                        chart: {
                            height: 330,
                        }
                    }
                },
                {
                    breakpoint: 1024,
                    options: {
                        chart: {
                            height: 300,
                        }
                    }
                },
                {
                    breakpoint: 768,
                    options: {
                        chart: {
                            height: 300,
                        }
                    }
                },
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 250,
                        },
                        xaxis: {
                            labels: {
                                rotate: -45,
                                hideOverlappingLabels: true
                            }
                        }
                    }
                }
            ]
        },
    }

    const zoomToRange = (startDate, endDate) => {
        if (chartRef.current) {
            chartRef.current.zoomX(startDate, endDate);
        }
    };

    const onChange = (date, dateString) => {
        if (!date) {
            chartRef.current.zoomX()
            return
        }
        let [startDate, endDate] = dateString
        startDate = new Date(startDate).getTime()
        endDate = new Date(endDate).getTime()
        zoomToRange(startDate, endDate);
    }

    return (
        <>
            <Heading as='h4' size='md'>
                Chart shows Resumes per Batch Operation vs Date
            </Heading>

            <div style={{ width: "100%", maxWidth: "1440px" }}>
                <Chart
                    options={chartData.options}
                    series={chartData.series}
                    type="area"
                    width="100%"
                    height="500"

                />
            </div>

            <RangePicker
                minDate={dayjs(minDate)}
                maxDate={dayjs(maxDate)}
                onChange={onChange} />
        </>
    )
}

export default ResumesCountChart